import { LoadingAnimation } from '@karnov/kui-react'

import { useCountry } from 'hooks/useCountry'

import type { FC } from 'react'

export const PageLoader: FC = () => {
  const country = useCountry()

  const tempCountry = ['dk', 'es', 'fr', 'no'].includes(country) ? 'dk' : 'se'

  return (
    <div
      className="flex h-screen items-center justify-center"
      role="progressbar"
    >
      <LoadingAnimation variant={tempCountry} height={100} width={100} />
    </div>
  )
}
